// @ts-nocheck
import * as React from 'react';
import {useEffect, useState} from 'react';
import {Route, Switch} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import {SouhrnPage} from './pages/SouhrnPage';
import {StromPage} from './pages/StromPage';
import {StatistikaPage} from './pages/StatistikaPage';
import CookieProvider from './contexts/CookieContext';
import {Helmet} from 'react-helmet';
import favicon from './favicon.png';
import {AppRouter} from '@mc/react-app-base';
import {SettingsApi} from './api';
import Cookies from 'js-cookie';
import {document} from '@probe.gl/env';
import {setGTM} from './utils/GATools';

const App = () => {
    const [containerId, setContainerId] = useState();

    useEffect(() => {
        SettingsApi.getCookiesInfo().then(res => {
            if (res.data && res.data.gtmContainerId && !containerId && containerId != res.data.gtmContainerId) {
                setContainerId(res.data.gtmContainerId);
            }
        });
    }, []);

    let cookiesAccepted = Cookies.get('CookieConsent');

    if (cookiesAccepted && containerId) {
        setGTM(containerId);
    }

    return (
        <CookieProvider>
            <Helmet>
                <html lang="cs" />
                <title>Prohlížečka rozpočtu</title>
                <link href={favicon} rel={'icon'} sizes={'any'} type={'image/png'} />
            </Helmet>
            <AppRouter>
                <Switch>
                    <Route exact path={'/'} component={SouhrnPage} />
                    <Route path={'/souhrn/:idVerze'} component={SouhrnPage} />
                    <Route path={'/strom/:idVerze'} exact component={StromPage} />
                    <Route path={'/strom/:idVerze/:id'} exact component={StromPage} />
                    <Route path={'/statistika/:idVerze'} component={StatistikaPage} />
                </Switch>
            </AppRouter>
        </CookieProvider>
    );
};

export default App;
